import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { teacherDashboardActions } from './teacherDashboardSlice';
import {
    getTeacherSummaryApi,
    getTeacherGradeSectionsApi,
    getTeacherMyGradesSectionsApi,
    getTeacherStudentsApi,
    getTeacherInsightsApi,
} from './teacherDashboardBaseApi';
import { toastAction } from '../toast/toast';

function* onLoadSummary() {
    try {
        yield put(teacherDashboardActions.setLoading(true));
        const response = yield call(getTeacherSummaryApi);
        yield put(teacherDashboardActions.setSummary(response?.data || null));
    } catch (error) {
        yield put(teacherDashboardActions.setError(error?.message || 'Failed to load summary'));
        yield put(toastAction.onErrorToast(error?.message || 'Failed to load dashboard'));
    }
}

function* onLoadGradeSections() {
    try {
        const response = yield call(getTeacherGradeSectionsApi);
        yield put(teacherDashboardActions.setGradeSections(response?.data || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || 'Failed to load grade-sections'));
    }
}

function* onLoadMyGradesSections() {
    try {
        const response = yield call(getTeacherMyGradesSectionsApi);
        yield put(teacherDashboardActions.setMyGradesSections(response?.data || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || 'Failed to load grade list'));
    }
}

function* onLoadStudents({ payload }) {
    try {
        yield put(teacherDashboardActions.setStudentsLoading(true));
        const response = yield call(getTeacherStudentsApi, payload || {});
        yield put(teacherDashboardActions.setStudents({
            data: response?.data || [],
            pagination: response?.pagination || {},
        }));
    } catch (error) {
        yield put(teacherDashboardActions.setError(error?.message || 'Failed to load students'));
        yield put(toastAction.onErrorToast(error?.message || 'Failed to load students'));
    }
}

function* onLoadInsights() {
    try {
        yield put(teacherDashboardActions.setInsightsLoading(true));
        const response = yield call(getTeacherInsightsApi);
        yield put(teacherDashboardActions.setInsights(response?.data || null));
    } catch (error) {
        yield put(teacherDashboardActions.setError(error?.message || 'Failed to load insights'));
        yield put(toastAction.onErrorToast(error?.message || 'Failed to load insights'));
    }
}

function* teacherDashboardWatcherSaga() {
    yield takeEvery(teacherDashboardActions.loadSummary.type, onLoadSummary);
    yield takeEvery(teacherDashboardActions.loadGradeSections.type, onLoadGradeSections);
    yield takeEvery(teacherDashboardActions.loadMyGradesSections.type, onLoadMyGradesSections);
    // takeLatest, not takeEvery: search/filter changes fire overlapping requests and a
    // slow earlier one must not overwrite the results of the newest one.
    yield takeLatest(teacherDashboardActions.loadStudents.type, onLoadStudents);
    yield takeEvery(teacherDashboardActions.loadInsights.type, onLoadInsights);
}

export default teacherDashboardWatcherSaga;
